import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// Dropdown of event names from admin settings; falls back to free text when the list is empty.
export default function EventNameSelect({ value, onChange, options = [], taken = [], testId, className = "" }) {
  if (!options.length) {
    return <Input required placeholder="cth. 500m Sprint" value={value} onChange={(e) => onChange(e.target.value)} data-testid={testId} className={className} />;
  }
  const list = value && !options.includes(value) ? [value, ...options] : options;
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger data-testid={testId} className={className}><SelectValue placeholder="Pilih mata lomba" /></SelectTrigger>
      <SelectContent>
        {list.map((o, i) => (
          <SelectItem key={o} value={o} disabled={o !== value && taken.includes(o)} data-testid={`${testId}-option-${i}`}>{o}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
